<template>
    <div>
        <HeaderBg :title="$t('adminHomePageData.title')" />

        <div class="form_container">
            <form @submit.prevent="addHome">
                <h2 class="sections-title">{{$t('adminHomePageData.sectionOne')}}</h2>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionOneImageAr')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionOneImgUrl == ''">
                        <img :src="sectionOneImgUrl" alt="" v-if="sectionOneImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionOneImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionOneImageEn')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionOneImgUrlEn == ''">
                        <img :src="sectionOneImgUrlEn" alt="" v-if="sectionOneImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionOneImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[0].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[0].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[0].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[0].translations[1].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[0].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[0].translations[1].description" />
                    </client-only>
                </div>
                <hr>


                <h2 class="sections-title">{{$t('adminHomePageData.sectionTwo')}}</h2>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionTwoImageAr')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionTwoImgUrl == ''">
                        <img :src="sectionTwoImgUrl" alt="" v-if="sectionTwoImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionTwoImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionTwoImageEn')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionTwoImgUrlEn == ''">
                        <img :src="sectionTwoImgUrlEn" alt="" v-if="sectionTwoImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionTwoImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[1].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[1].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[1].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[1].translations[1].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[1].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[1].translations[1].description" />
                    </client-only>
                </div>
                <hr>


                <h2 class="sections-title">{{$t('adminHomePageData.sectionThree')}}</h2>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionThreeImageAr')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionThreeImgUrl == ''">
                        <img :src="sectionThreeImgUrl" alt="" v-if="sectionThreeImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionThreeImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionThreeImageEn')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionThreeImgUrlEn == ''">
                        <img :src="sectionThreeImgUrlEn" alt="" v-if="sectionThreeImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionThreeImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[2].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[2].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[2].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[2].translations[1].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[2].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[2].translations[1].description" />
                    </client-only>
                </div>


                <h2 class="sections-title">{{$t('adminHomePageData.sectionFour')}}</h2>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionFourImageAr')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionFourImgUrl == ''">
                        <img :src="sectionFourImgUrl" alt="" v-if="sectionFourImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionFourImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionFourImageEn')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionFourImgUrlEn == ''">
                        <img :src="sectionFourImgUrlEn" alt="" v-if="sectionFourImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionFourImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[3].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[3].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[3].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[3].translations[1].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[3].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[3].translations[1].description" />
                    </client-only>
                </div>
                <h2 class="sections-title">{{$t('adminHomePageData.sectionFive')}}</h2>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionFiveImageAr')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionFiveImgUrl == ''">
                        <img :src="sectionFiveImgUrl" alt="" v-if="sectionFiveImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionFiveImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminHomePageData.sectionFiveImageEn')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionFiveImgUrlEn == ''">
                        <img :src="sectionFiveImgUrlEn" alt="" v-if="sectionFiveImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionFiveImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[4].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[4].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[4].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[4].translations[1].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[4].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminHomePageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[4].translations[1].description" />
                    </client-only>
                </div>
                
                <div class="alert alert-success mt-2" role="alert" v-if="successMessage">
                    {{$t('adminHomePageData.successMessage')}}
                </div>
                <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck == true">
                    <p v-for="(error, index) in errors" :key="index"> {{error}} </p>
                </div>
                <button class="saveBtn" v-if="postLoaded == false">
                    {{$t('adminHomePageData.save')}}
                </button>
                <button class="saveBtn" v-if="postLoaded == true"><b-spinner></b-spinner></button>
            </form>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Request from '../../../services/Request';
import { VueEditor } from "vue2-editor";
export default {
    name :'HomePageData',
    components: {HeaderBg, VueEditor},
    data(){
        return{
            postLoaded: false,
            successMessage: false,
            sectionOneImgUrl: '',
            sectionOneImgUrlEn: '',
            sectionTwoImgUrl: '',
            sectionTwoImgUrlEn: '',
            sectionThreeImgUrl: '',
            sectionThreeImgUrlEn: '',
            sectionFourImgUrl: '',
            sectionFourImgUrlEn: '',
            sectionFiveImgUrl: '',
            sectionFiveImgUrlEn: '',

            // fourth section
            home: {
                sections: [
                    {
                        image: '',
                        image_en: '',
                        section: 1,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        image_en: '',
                        section: 2,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",

                            
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        image_en: '',
                        section: 3,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",

                            
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        image_en: '',
                        section: 4,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",

                            
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        image_en: '',
                        section: 5,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",

                            
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    }
                ]
            },
            errors: [],
            ErrorCheck: false,
        }
    },
    mounted(){
        this.getHomePageSectionOne();
        this.getHomePageSectionTwo();
        this.getHomePageSectionThree();
        this.getHomePageSectionFour();
        this.getHomePageSectionFive();
    },
    methods:{
        addHome() {
            this.successMessage = false;
            this.postLoaded = true;
            this.errors = [];
            this.ErrorCheck = false;

            const formData = new FormData();

            // ✅ append images
            if (this.home.sections[0].image) {
                formData.append("sections[0][image]", this.home.sections[0].image);
            }
            if (this.home.sections[0].image_en) {
                formData.append("sections[0][image_en]", this.home.sections[0].image_en);
            }
            if (this.home.sections[1].image) {
                formData.append("sections[1][image]", this.home.sections[1].image);
            }
            if (this.home.sections[1].image_en) {
                formData.append("sections[1][image_en]", this.home.sections[1].image_en);
            }
            if (this.home.sections[2].image) {
                formData.append("sections[2][image]", this.home.sections[2].image);
            }
            if (this.home.sections[2].image_en) {
                formData.append("sections[2][image_en]", this.home.sections[2].image_en);
            }
            if (this.home.sections[3].image) {
                formData.append("sections[3][image]", this.home.sections[3].image);
            }
            if (this.home.sections[3].image_en) {
                formData.append("sections[3][image_en]", this.home.sections[3].image_en);
            }
            if (this.home.sections[4].image) {
                formData.append("sections[4][image]", this.home.sections[4].image);
            }
            if (this.home.sections[4].image_en) {
                formData.append("sections[4][image_en]", this.home.sections[4].image_en);
            }
      
            // ✅ append translations (ar/en)
            this.home.sections.forEach((data, index) => {
                formData.append(`sections[${index}][section]`, data.section);
                data.translations.forEach((t, indexx) => {
                    Object.keys(t).forEach(key => {
                        formData.append(`sections[${index}][translations][${indexx}][${key}]`, t[key]);
                    });
                });    
            });
            

            axios.post("https://app.almujtama.com.sa/admin/home_page_sections", formData, {
                headers: { 
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "multipart/form-data"
                }
            })
            .then(() => {
                this.postLoaded = false;
                this.ErrorCheck = false;
                this.successMessage = true;
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    this.errors = err.response.data.errors;
                    this.ErrorCheck = true;
                }
                this.postLoaded = false;
            });
        },
        uploadSectionOneImgUrl(e) {
            this.home.sections[0].image = e.target.files[0];
            this.sectionOneImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionOneImgUrlEn(e) {
            this.home.sections[0].image_en = e.target.files[0];
            this.sectionOneImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionTwoImgUrl(e) {
            this.home.sections[1].image = e.target.files[0];
            this.sectionTwoImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionTwoImgUrlEn(e) {
            this.home.sections[1].image_en = e.target.files[0];
            this.sectionTwoImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionThreeImgUrl(e) {
            this.home.sections[2].image = e.target.files[0];
            this.sectionThreeImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionThreeImgUrlEn(e) {
            this.home.sections[2].image_en = e.target.files[0];
            this.sectionThreeImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionFourImgUrl(e) {
            this.home.sections[3].image = e.target.files[0];
            this.sectionFourImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionFourImgUrlEn(e) {
            this.home.sections[3].image_en = e.target.files[0];
            this.sectionFourImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionFiveImgUrl(e) {
            this.home.sections[4].image = e.target.files[0];
            this.sectionFiveImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionFiveImgUrlEn(e) {
            this.home.sections[4].image_en = e.target.files[0];
            this.sectionFiveImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
  
        
        getHomePageSectionOne(){
            Request.fetch(`admin/home_page_sections/1`, '')
            .then((response) => {
                this.sectionOneImgUrl= response.data.data.image,
                this.sectionOneImgUrlEn= response.data.data.image_en,
                this.home.sections[0].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getHomePageSectionTwo(){
            Request.fetch(`admin/home_page_sections/2`, '')
            .then((response) => {
                this.sectionTwoImgUrl= response.data.data.image,
                this.sectionTwoImgUrlEn= response.data.data.image_en,
                this.home.sections[1].translations = response.data.data.translations;

            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getHomePageSectionThree(){
            Request.fetch(`admin/home_page_sections/3`, '')
            .then((response) => {
                this.sectionThreeImgUrl= response.data.data.image,
                this.sectionThreeImgUrlEn= response.data.data.image_en,
                this.home.sections[2].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getHomePageSectionFour(){
            Request.fetch(`admin/home_page_sections/4`, '')
            .then((response) => {
                this.sectionFourImgUrl= response.data.data.image,
                this.sectionFourImgUrlEn= response.data.data.image_en,
                this.home.sections[3].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getHomePageSectionFive(){
            Request.fetch(`admin/home_page_sections/5`, '')
            .then((response) => {
                this.sectionFiveImgUrl= response.data.data.image,
                this.sectionFiveImgUrlEn= response.data.data.image_en,
                this.home.sections[4].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            margin-bottom: 40px;
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 50%;
            }
        }
        button{
            margin: 30px auto 0 auto;   
        }
    }
}
.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-inline-end: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
</style>